export default "__VITE_ASSET__CY4fzzTB__"